import ScoreManager from '../Utils/ScoreManager.js'

export default function showDragDropOverlay() {
    const overlay = document.getElementById('dragDropOverlay')
    if (!overlay || !overlay.classList.contains('hidden')) return

    overlay.classList.remove('hidden')

    const draggables = overlay.querySelectorAll('.draggable')
    const dropZonesFocus = document.querySelectorAll('.drop-zone-focus')
    const dropZonesAvoid = document.querySelectorAll('.drop-zone-avoid')

    let draggedText = null

    // Drag and touch support
    draggables.forEach(item => {
        item.addEventListener('dragstart', (e) => {
            draggedText = e.target.innerText
            e.dataTransfer.effectAllowed = "move"
            e.dataTransfer.setData('text/plain', draggedText)
        })

        item.addEventListener('touchstart', () => {
            draggedText = item.innerText
            item.classList.add('dragging')
        })

        item.addEventListener('touchend', () => {
            item.classList.remove('dragging')
        })
    })

    function setupDropZones(zones) {
        zones.forEach(zone => {
            zone.addEventListener('dragover', (e) => {
                e.preventDefault()
                zone.style.background = '#f0f0f0'
            })
            zone.addEventListener('dragleave', () => {
                zone.style.background = ''
            })
            zone.addEventListener('drop', (e) => {
                e.preventDefault()
                const text = e.dataTransfer.getData('text/plain')
                zone.innerText = text
                zone.style.background = 'white'

                const toRemove = Array.from(document.querySelectorAll('.draggable')).find(el => el.innerText === text)
                if (toRemove) {
                    toRemove.remove()
                }

            })
            zone.addEventListener('touchmove', (e) => e.preventDefault())
            zone.addEventListener('touchend', () => {
                if (draggedText) {
                    zone.innerText = draggedText
                    zone.style.background = 'white'

                    const toRemove = Array.from(document.querySelectorAll('.draggable')).find(el => el.innerText === draggedText)
                    if (toRemove) {
                        toRemove.remove()
                    }

                    draggedText = null
                }
            })
        })
    }

    setupDropZones(dropZonesFocus)
    setupDropZones(dropZonesAvoid)

    document.getElementById('checkOrderBtn').addEventListener('click', () => {
        const correctFocus = [
            'Ein Mini-Workshop mit ausgewählten Mitarbeitenden hilft dabei, Klarheit über das Ziel zu erlangen.',
            'So formulieren, als könnte der Satz im Schaufenster oder der Eingangstür stehen.',
            'Eine Satzvorlage kann helfen.',
            'Wenn ein erste Entwurf steht, dann gilt es früh und zielgenau bei ausgewählten Mitarbeitenden Feedback einzuholen.'
        ]

        const correctAvoid = [
            'Technische und abstrakte Formulierungen, um professioneller zu klingen.',
            'Details und konkrete Maßnahmen benennen.',
            'Frei formulieren und die eigenen Werte außer Acht lassen.',
            'Perspektive aus der Geschäftsführung annehmen und die Rolle der Mitarbeitenden weniger berücksichtigen.'
        ]

        function arraysMatchIgnoreOrder(userArray, correctArray) {
            const normalize = text => text.trim().toLowerCase().replace(/\s+/g, ' ')
            const userSet = new Set(userArray.map(normalize))
            const correctSet = new Set(correctArray.map(normalize))
        
            if (userSet.size !== correctSet.size) return false
        
            for (const item of correctSet) {
                if (!userSet.has(item)) return false
            }
        
            return true
        }
        
        
        const msg = document.getElementById('resultMessage')

        const userFocus = Array.from(document.querySelectorAll('.drop-zone-focus')).map(el => el.innerText);
        const userAvoid = Array.from(document.querySelectorAll('.drop-zone-avoid')).map(el => el.innerText);
                      
        const isFocusCorrect = arraysMatchIgnoreOrder(userFocus, correctFocus)
        const isAvoidCorrect = arraysMatchIgnoreOrder(userAvoid, correctAvoid)
        
                      
        if (isFocusCorrect && isAvoidCorrect) {
            msg.innerText = '✅ Alles korrekt!' 
            msg.style.color = 'lightgreen'
            ScoreManager.add(1)
            setTimeout(() => overlay.classList.add('hidden'), 1000)
        } else {
            msg.innerText = '❌ Leider nicht korrekt!'
            msg.style.color = 'red'
        }
    })

    window.addEventListener('keydown', function escHandler(e) {
        if (e.key === 'Escape') {
            overlay.classList.add('hidden')
            window.removeEventListener('keydown', escHandler)
        }
    })
    document.getElementById('closeDragDropBtn').addEventListener('click', () => {
        overlay.classList.add('hidden')
    })    
    
}
